"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.saveFailed = exports.saveSuccess = exports.saveRequest = exports.searchFailed = exports.searchSuccess = exports.searchRequest = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = void 0;
const ActionTypes = require("../../actionTypes/modelspace/project");
const fetchRequest = (projectId) => ({
    type: ActionTypes.FETCH_REQUEST,
    payload: projectId
});
exports.fetchRequest = fetchRequest;
const fetchSuccess = (configuration) => ({
    type: ActionTypes.FETCH_SUCCESS,
    payload: configuration
});
exports.fetchSuccess = fetchSuccess;
const fetchFailed = (message) => ({
    type: ActionTypes.FETCH_FAILED,
    payload: message
});
exports.fetchFailed = fetchFailed;
const searchRequest = (configuration, projectId, modelspaceProjectNumber) => ({
    type: ActionTypes.SEARCH_REQUEST,
    payload: {
        configuration,
        projectId,
        modelspaceProjectNumber
    }
});
exports.searchRequest = searchRequest;
const searchSuccess = (configuration) => ({
    type: ActionTypes.SEARCH_SUCCESS,
    payload: configuration
});
exports.searchSuccess = searchSuccess;
const searchFailed = (message) => ({
    type: ActionTypes.SEARCH_FAILED,
    payload: message
});
exports.searchFailed = searchFailed;
const saveRequest = (projectId, configuration) => ({
    type: ActionTypes.SAVE_REQUEST,
    payload: {
        projectId,
        configuration
    }
});
exports.saveRequest = saveRequest;
const saveSuccess = () => ({
    type: ActionTypes.SAVE_SUCCESS
});
exports.saveSuccess = saveSuccess;
const saveFailed = (message) => ({
    type: ActionTypes.SAVE_FAILED,
    payload: message
});
exports.saveFailed = saveFailed;
function clear() {
    return {
        type: ActionTypes.CLEAR
    };
}
exports.clear = clear;
//# sourceMappingURL=project.js.map